<div class="carouselcontainer">
  <div class="carousel slide" id="carouselindicators">
    <ol class="carousel-indicators">
      <li
        #carouselind
        (click)="GoToCarousel($event, i)"
        *ngFor="let image of images; let i = index"
        [ngClass]="i === 0 ? 'active' : ''"
        class="carousalind"
        data-slide-to="i"
        data-target="#carouselindicators"
      ></li>
    </ol>
    <div class="caraousel-inner">
      <div
        #carouselitem
        *ngFor="let image of images; let i = index"
        [ngClass]="i === 0 ? 'active' : ''"
        class="carousel-item carouselimage{{ i }}"
      >
        <img
          *ngIf="image.imgUrl"
          alt="{{ image.alt }}"
          class="d-block w-100"
          src="{{ image.imgUrl }}"
          [attr.loading]="i === 0 ? 'eager' : loadingStrategy"
          (error)="failure.emit(image.imgUrl)"
        />
        <img
          *ngIf="image.url"
          alt="{{ image.alt }}"
          class="d-block w-100"
          src="{{ image.url }}"
          [attr.loading]="i === 0 ? 'eager' : loadingStrategy"
          (error)="failure.emit(image.url)"
        />
        <div *ngIf="description === 'true'" class="carousal-description">
          <span *ngIf="image.heading" class="item-heading">
            {{ image.heading }}
          </span>
          <span
            *ngIf="image.description"
            [innerHTML]="image.description"
            class="item-desc"
          ></span>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showCarouselNextPrev">
      <a
        class="carousel-control-prev"
        href="#carouselindicators"
        role="button"
        data-slide="prev"
        (click)="showPrevCarousel($event)"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">{{ ariaLabel.previous }}</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselindicators"
        role="button"
        data-slide="next"
        (click)="showNextCarousel($event)"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">{{ ariaLabel.next }}</span>
      </a>
    </ng-container>
  </div>
</div>
